import { AccountInfo, IPublicClientApplication } from '@azure/msal-browser';
import { AuthorizationError } from '@Praia-Health/spi-common-utils/browser';
import { ApiRequestLogger } from '../logger/apiRequestLogger';
import { getClientCorrelationId } from '../logger/logMetadata';

/**
 * @deprecated
 * This function does nothing. Just call instance.acquireTokenSilent directly and handle the error case
 */
export default async function getAccessToken(instance: IPublicClientApplication, accounts: AccountInfo[], scopes: string[], log: ApiRequestLogger): Promise<string> {
    return await instance
        .acquireTokenSilent({
            account: accounts[0],
            scopes,
            correlationId: getClientCorrelationId(),
        })
        .then((response: { accessToken: any }) => {
            if (response.accessToken) {
                return response.accessToken;
            }
            log.error(`getAccessToken(): Failed to acquire token`);
            throw new AuthorizationError('Failed to acquire token');
        })
        .catch((error) => {
            log.error(`getAccessToken(): Failed to acquire token ${error.message}`);
            throw error;
        });
}
